import { ReactNode } from "react";
import { Text, View, XStack } from "tamagui";

import { GradientCard, GradientCardProps } from "./GradientCard";

export interface BorderedCardProps extends GradientCardProps {
  title: string;
  icon?: ReactNode;
}

export const BorderedCard = ({
  title,
  icon,
  children,
  ...rest
}: BorderedCardProps) => (
  // Side by side on a full desktop, stacked below `lg` (Analytics is the
  // only consumer; its rows wrap).
  <View flexGrow={1} flexBasis={0} $lg={{ flexBasis: "100%" }}>
    <GradientCard height="100%" overflow="hidden" {...rest}>
      <XStack justifyContent="space-between" alignItems="center">
        <Text fontWeight="bold" zIndex={2}>
          {title}
        </Text>
        {icon}
      </XStack>
      <View flexGrow={1} zIndex={1}>
        {children}
      </View>
    </GradientCard>
  </View>
);
